import React from 'react';
import { DataGrid } from '@mui/x-data-grid';

import pallet from '../../../layouts/pallet';
import { dataGridSx } from '../../common/styled/DataGrid';
import { StudentDetails } from '../types';
import { getSearchStudentFeeEntryColumns } from '../utils/SearchStudentFeeEntryColumns';
import { PaperWrapper } from '../../common/styled';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

interface SearchStudentFeeEntryTableProps {
  studentProfileData: StudentDetails[];
  isLoading: boolean;
  onFeeDetailsClick: (studentId: string) => void;
}

const SearchStudentFeeEntryTable: React.FC<SearchStudentFeeEntryTableProps> = ({
  studentProfileData,
  isLoading,
  onFeeDetailsClick
}) => {
  const columns = getSearchStudentFeeEntryColumns(onFeeDetailsClick);

  return (
    <PaperWrapper sx={{ paddingTop: '16px !important' }}>
      <DataGrid
        rowHeight={50}
        rows={studentProfileData}
        columns={columns}
        loading={isLoading}
        disableRowSelectionOnClick
        pageSizeOptions={[5, 10, 25]}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 10 }
          }
        }}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PaperWrapper>
  );
};

export default SearchStudentFeeEntryTable;
